import { gql, useMutation } from '@apollo/client'
import { useNotification } from '@btime/react-messager'

import { placesClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation UpsertPlaceLevel($input: PlaceLevelInput) {
    upsertPlaceLevel(input: $input) {
      id
      name
    }
  }
`

export const useSavePlaceLevel = (onSuccess, initialInput) => {
  const notify = useNotification()
  const [request, state] = useMutation(MUTATION, { client: placesClient })

  const handleRequest = name => {
    const input = { ...initialInput, name }

    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) {
        if (!!onSuccess) onSuccess(resp.data?.upsertPlaceLevel)
      } else {
        notify.error({ title: 'Ocorreu um erro ao salvar!' })
      }
    })
  }

  return [handleRequest, state]
}
